module.exports = __webpack_public_path__ + "static/media/ic_search.375dde57.svg";